import { FC, useEffect, useRef } from "react";
import { GroupBase, OptionsOrGroups } from "react-select";
import { Controller, useForm } from "react-hook-form";

import StatsReports from "../statsReports";
import HubInputField from "src/components/inputType";

import { CASE_FITLER, COMPARISON_FILTER, GROUP_BY_FILTER } from "src/constants/manufacturer";
import { StatisticsPropsType, StatisticsSearchProps } from "./types";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import { format, parse } from "date-fns";


const CaseFilter: FC<StatisticsPropsType> = ({ updateQueryParams, defaultQueryParams }): JSX.Element => {
  const startDateRef = useRef<DatePicker | null>(null)
  const endDateRef = useRef<DatePicker | null>(null)
  const startDateWrapperRef = useRef<HTMLDivElement | null>(null)
  const endDateWrapperRef = useRef<HTMLDivElement | null>(null)
  // useEffect(() => {
  //   document.addEventListener("touchend", () => {
  //     if (startDateRef.current) {
  //       if (startDateRef.current.isCalendarOpen()) startDateRef.current.setOpen(false)
  //     }
  //     if (endDateRef.current) {
  //       if (endDateRef.current.isCalendarOpen()) endDateRef.current.setOpen(false)
  //     }
  //   });
  //   return () => document.removeEventListener("touchend", () => {
  //     if (startDateRef.current) {
  //       // eslint-disable-next-line react-hooks/exhaustive-deps
  //       if (startDateRef.current.isCalendarOpen()) startDateRef.current.setOpen(false)
  //     }
  //     if (endDateRef.current) {
  //       // eslint-disable-next-line react-hooks/exhaustive-deps
  //       if (endDateRef.current.isCalendarOpen()) endDateRef.current.setOpen(false)
  //     }
  //   });
  // }, []);

  useEffect(() => {
    const closeOnOutsideTap = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node;

      if (startDateWrapperRef.current && !startDateWrapperRef.current.contains(target)) {
        if (startDateRef.current?.isCalendarOpen()) startDateRef.current.setOpen(false);
      }

      if (endDateWrapperRef.current && !endDateWrapperRef.current.contains(target)) {
        if (endDateRef.current?.isCalendarOpen()) endDateRef.current.setOpen(false);
      }
    };

    document.addEventListener("mousedown", closeOnOutsideTap);
    document.addEventListener("touchstart", closeOnOutsideTap);

    return () => {
      document.removeEventListener("mousedown", closeOnOutsideTap);
      document.removeEventListener("touchstart", closeOnOutsideTap);
    };
  }, []);




  const { control, handleSubmit, getValues, watch } = useForm<StatisticsSearchProps>({
    mode: "all",
    defaultValues: defaultQueryParams,
  });
  const start_date = watch("start_date");
  const end_date = watch("end_date");
  const searchForStats = (values: StatisticsSearchProps) => {
    const updatedValues = {
      ...values,
      period: values.period
        ? typeof values.period === "string"
          ? values.period
          : (values.period as unknown as { value: string; label: string }).value
        : "",
      soc_value:
        values.soc_value ?
          (typeof values.soc_value === "string" ? values.soc_value : (values.soc_value as unknown as { value: string; name: string; }).value)
          : "",
      drug_id:
        values.drug_id ?
          (typeof values.drug_id === "string" ? values.drug_id : (values.drug_id as unknown as { value: string; name: string; }).value)
          : "",
      filter_type: values.filter_type
        ? typeof values.filter_type === "string"
          ? values.filter_type
          : (values.filter_type as unknown as { value: string; label: string }).value
        : "",
      user_id:
        values.user_id ?
          (typeof values.user_id === "string" ? values.user_id : (values.user_id as unknown as { value: string; name: string; }).value)
          : "",
    };

    updateQueryParams(updatedValues, false);
  };



  return (
    <form onSubmit={handleSubmit(searchForStats)}>
      <div className="card mt-4 mb-3">
        <div className="card-header">
          <h4 className="m-0">Statistics</h4>
        </div>
        <div className="card-body px-3 pt-3">
          <div className="row g-2 statistics-filter">
            <div className="col date-col mt-0 mb-3 position-relative" ref={startDateWrapperRef}>
              <Controller
                name="start_date"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <>
                    <DatePicker
                      ref={startDateRef}
                      value={field.value && format(parse(field.value, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")}
                      // selected={state.date_from.length > 0 ? parse(state.date_from, "yyyy-MM-dd", new Date()) : null}
                      // onChange={handleDateFromChange}
                      selected={field.value && field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                      onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                      dateFormat="MM/dd/yyyy"
                      icon="bi bi-calendar"
                      showMonthDropdown
                      showYearDropdown
                      className="form-control rounded-1"
                      wrapperClassName="w-100"
                      placeholderText="mm/dd/yyyy"
                      customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                        <input {...inputProps} />}</ReactInputMask>}
                      maxDate={end_date ? new Date(end_date) : undefined}
                      onClickOutside={() => {
                        if (startDateRef.current) startDateRef.current.setOpen(false)
                      }}
                    />
                    <i
                      className="bi bi-calendar position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    ></i>
                  </>
                  // <DatePicker
                  //   ref={startDateRef}
                  //   selected={field.value && field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                  //   onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                  //   customInput={
                  //     <ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                  //       <input {...inputProps} />}
                  //     </ReactInputMask>
                  //   }
                  //   className="form-control rounded-1" wrapperClassName="w-100"
                  //   placeholderText="mm/dd/yyyy"
                  //   dateFormat="MM/dd/yyyy"
                  //   showMonthDropdown
                  //   showYearDropdown
                  //   maxDate={end_date ? new Date(end_date) : undefined}
                  //   onClickOutside={() => {
                  //     if (startDateRef.current) startDateRef.current.setOpen(false)
                  //   }}
                  // />
                )}
              />
            </div>
            <div className="col date-col mt-0 mb-3 position-relative" ref={endDateWrapperRef}>
              <Controller
                name="end_date"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  // <DatePicker
                  //   ref={endDateRef}
                  //   selected={field.value && field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                  //   onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                  //   customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) => <input {...inputProps} />}</ReactInputMask>}
                  //   className="form-control rounded-1" wrapperClassName="w-100"
                  //   placeholderText="mm/dd/yyyy"
                  //   dateFormat="MM/dd/yyyy"
                  //   showMonthDropdown
                  //   showYearDropdown
                  //   minDate={start_date ? new Date(start_date) : undefined}
                  //   onClickOutside={() => {
                  //     if (endDateRef.current) endDateRef.current.setOpen(false)
                  //   }}
                  // />
                  <>
                    <DatePicker
                      ref={endDateRef}
                      value={field.value && format(parse(field.value, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")}
                      selected={field.value && field.value.length > 0 ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                      onChange={(date) => date ? field.onChange(format(date, "yyyy-MM-dd")) : ""}
                      dateFormat="MM/dd/yyyy"
                      className="form-control rounded-1" wrapperClassName="w-100"
                      placeholderText="mm/dd/yyyy"
                      showMonthDropdown
                      showYearDropdown
                      customInput={<ReactInputMask mask="99/99/9999">{(inputProps: {}) =>
                        <input {...inputProps} />}</ReactInputMask>}
                      minDate={start_date ? new Date(start_date) : undefined}
                      onClickOutside={() => {
                        if (endDateRef.current) endDateRef.current.setOpen(false)
                      }}
                    />
                    <i
                      className="bi bi-calendar position-absolute"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    ></i></>
                )}
              />
            </div>
            <div className="col mt-0">
              <Controller
                name="period"
                control={control}
                render={({ field }) => (
                  <HubInputField
                    field={field}
                    inputId="period"
                    isRequired={false}
                    isRowBased={false}
                    isDropdown={true}
                    isSearchable={false}
                    inputPlaceholder="Group Report By..."
                    isTypeAhead
                    dropdownData={
                      GROUP_BY_FILTER as unknown as OptionsOrGroups<string, GroupBase<string>>
                    }
                  />
                )}
              />
            </div>
            <div className="col patient-col mt-0">
              <Controller
                name="filter_type"
                control={control}
                // defaultValue=""
                render={({ field }) => (
                  <HubInputField
                    field={field}
                    inputId="period"
                    isRequired={false}
                    isRowBased={false}
                    isDropdown={true}
                    isSearchable={false}
                    inputPlaceholder="Compare With..."
                    isTypeAhead
                    dropdownData={
                      COMPARISON_FILTER as unknown as OptionsOrGroups<string, GroupBase<string>>
                    }
                  />
                )}
              />
            </div>
            <div className="col mt-0">
              <Controller
                name="case_filter"
                control={control}
                // defaultValue={comparison[0].value}
                render={({ field }) => (
                  <HubInputField
                    field={field}
                    inputId="period"
                    isRequired={false}
                    isRowBased={false}
                    isDropdown={true}
                    isSearchable={false}
                    inputPlaceholder="Filter..."
                    isTypeAhead
                    dropdownData={
                      CASE_FITLER as unknown as OptionsOrGroups<string, GroupBase<string>>
                    }
                  />
                )}
              />
            </div>
            <div className="col mt-0 mb-3">
              <button type="submit" className="btn btn-primary text-nowrap">
                <i className="fas fa-sync-alt"></i>{' '}
                Refresh
              </button>
            </div>

          </div>

          <StatsReports getValues={getValues} />
        </div>

      </div>

    </form >
  );
};

export default CaseFilter;
